var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "ModalMantenedor",
    { attrs: { show: _vm.show } },
    [
      _c("CabeceraModal", {
        attrs: { titulo: "Ver Detalle Cliente Proveedor de GPS" },
        on: { cerrar: _vm.handleCerrar }
      }),
      _c("CrudStepsNavBar", {
        attrs: { pasos: _vm.pasos, "validar-paso": false },
        model: {
          value: _vm.pasoActivoIndex,
          callback: function($$v) {
            _vm.pasoActivoIndex = $$v
          },
          expression: "pasoActivoIndex"
        }
      }),
      _c(
        "ContenidoModal",
        [
          _c("ClienteProveedorForm", {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value:
                  _vm.pasoActivoIndex === _vm.pasos.informacionGeneral.step,
                expression: "pasoActivoIndex === pasos.informacionGeneral.step"
              }
            ],
            attrs: {
              clienteProveedorSeleccionado: _vm.lstClienteProveedor.data,
              modoVer: true
            }
          }),
          _c("ProveedorGrid", {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value:
                  _vm.pasoActivoIndex ===
                  _vm.pasos.asociarClienteProveedor.step,
                expression:
                  "pasoActivoIndex === pasos.asociarClienteProveedor.step"
              }
            ],
            attrs: {
              modoVer: true,
              clienteProveedorSeleccionado: _vm.lstClienteProveedor.data,
              proveedores: _vm.lstProveedores
            }
          })
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }